declare global {
  interface Document {
    mozHidden: boolean;
    webkitHidden: boolean;
    msHidden: boolean;
  }
}

export function onVisibilityChange(callback: (isFocused: boolean) => void) {
  if ('hidden' in document) {
    window.document.addEventListener('visibilitychange', () => {
      callback(!window.document.hidden);
    });
  } else if ('mozHidden' in document) {
    window.document.addEventListener('mozvisibilitychange', () => {
      callback(!document.mozHidden);
    });
  } else if ('webkitHidden' in document) {
    window.document.addEventListener('webkitvisibilitychange', () => {
      callback(!document.webkitHidden);
    });
  } else if ('msHidden' in document) {
    window.document.addEventListener('msvisibilitychange', () => {
      callback(!document.msHidden);
    });
  }
}
